import React, { useState } from "react";
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { ls } from "../../../variables";
import Swal from 'sweetalert2';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { encrypt } from '../../../utils/cipher';
import Styles from "./index.module.css";
import { errorHandler } from "../../../utils/errorHandling";
import { useStateValue } from "../../../Hooks/stateProvider";
import BarLoader  from "react-spinners/BarLoader";


export default function DownloadDropDown({ moduleType, fileLocations, pmsName }) {


    const override = {
        margin: "0  0 auto",
        width:"100%"
      };
      
    const [{ fy_year, quarter }, dispatch] =
        useStateValue();
    const [anchorEl, setAnchorEl] = useState(null);
    const [loader, setLoader] = useState(false);
    // const [open, setOpen] = useState(false);
    const open = Boolean(anchorEl)
    const navigate = useNavigate();
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        // setOpen(true);
    };
    const handleClose = () => {
        setAnchorEl(null);
        // setOpen(false);
    };


    const downloadDocs = async () => {
        const payload = {
            pmsCode: pmsName,
            fy_year: fy_year,
            quarter: quarter,
            moduleType: moduleType.toUpperCase(),
            authToken: ls.get("authToken"),
            refreshToken: ls.get("refreshToken"),
        };
        setLoader(true)
        const encryptedPayload = await encrypt(payload);
        axios
            .post(
                "/api/pms/downloadDocs",
                { payload: encryptedPayload }, {
                responseType: 'blob', // Important: specify response type as blob
            }
            )
            .then((response) => {
                // Create a URL for the blob
                const url = window.URL.createObjectURL(new Blob([response.data]));

                // Create a link element
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${fy_year}_${quarter}_${pmsName}.zip`); // Specify the file name

                // Append to body and trigger click
                document.body.appendChild(link);
                link.click();
                setLoader(false)
                // Clean up and remove the link
                link.remove();
            })
            .catch((err) => {
                if(err.data === undefined){
                     Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "No File Found!",
                        confirmButtonColor: "#154063",
                        confirmButtonText: "OK",
                    });
                    setLoader(false)
                    setAnchorEl(null)
                } else{
                errorHandler(err, navigate)
                setLoader(false)
            }
            });
    }

    const downloadFile = async (location) => {
        const payload = {
            s3Location: location,
            moduleType: moduleType.toUpperCase(),
            authToken: ls.get("authToken"),
            refreshToken: ls.get("refreshToken"),
        };
        setLoader(true)
        const encryptedPayload = await encrypt(payload);
        axios
            .post(
                "/api/pms/downloadReport",
                { payload: encryptedPayload }
            )
            .then((val) => {
                
                // console.log("the value is",val);
                window.open(val.data.data, "_self");
                setLoader(false)
            })
            .catch((err) => {
                // console.log("mmm")
                // if(err.data === undefined){
                //      Swal.fire({
                //         icon: "error",
                //         title: "Oops...",
                //         text: "No File Found!",
                //         confirmButtonColor: "#154063",
                //         confirmButtonText: "OK",
                //     });
                //     setLoader(false)
                // } else{
                errorHandler(err, navigate)
                setLoader(false)
            // }
            });
    }

    return (
        <div >
            <Button
                className={Styles.DownloadCTRHYTR}
                id="demo-customized-button"
                aria-controls={open ? 'demo-customized-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                variant="contained"
                onClick={handleClick}
            >
                Download
                <KeyboardArrowDownIcon />
            </Button>
            <Menu
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                <MenuItem disabled={!fileLocations?.s3_location } onClick={() => { downloadFile(fileLocations?.s3_location) }}>Download {moduleType.toUpperCase()==='CMM'?'CMM':moduleType.toUpperCase()} File</MenuItem>
                <MenuItem
                    disabled={!fileLocations?.exceptional_files_s3_location}
                    onClick={() => {
                        if (moduleType === "cmm") {
                            downloadFile(fileLocations?.exceptional_files_s3_location);
                        }
                    }}
                >
                    Download Exceptional Files
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        if (moduleType === "cmm") {
                            downloadDocs();
                        }
                    }}
                >
                    Download Docs
                   
                </MenuItem>
            { loader && <BarLoader  cssOverride={override} color="#154063" /> }
            </Menu>
        </div >
    );
}
